export const copyToClipboard = (
    url: string,
    onSuccess: () => void,
    onError?: (error: any) => void
) => {
    navigator.clipboard
        .writeText(url)
        .then(onSuccess)
        .catch((error) => {
            onError ? onError(error) : console.error('Error copying URL to clipboard: ', error);
        });
};
